export default "__VITE_ASSET__a6d46dc7__"